import { FlowRouteComponentProps } from 'components/render-prop-components/FlowRoute';
import { Head } from 'head/Head';
import { RouteComponentProps } from 'react-router';
import { StoreType } from '@tock/shared/utils/connect';
import { Typography } from 'omakase';
import { consumer } from '@tock/coretypes';
import { optionsRouteMapStateToProps } from 'routes/business/tableside-flow/OptionsRoute';

import { useSelector } from 'react-redux';
import Options from 'components/business/checkout/Options';
import React from 'react';
import RescheduleHeader from 'components/account/reschedule/RescheduleHeader';

type Props = RouteComponentProps &
  FlowRouteComponentProps & {
    onUpdatePrice(): Promise<unknown>;
    business?: consumer.IBusinessConfig;
    lock: StoreType['lock'];
    onLockExpiration(): void;
    showOptions: boolean;
  };

const RescheduleOptionsRoute: React.FunctionComponent<Props> = (props) => {
  const selectorProps = useSelector(optionsRouteMapStateToProps);

  const handleClickBack = () => {
    props.history.goBack();
  };

  return (
    <div className="Reschedule-content PageContent-inner-bottom-only">
      <Head title={`${props.business?.name} Reschedule - Add ons`} />
      <RescheduleHeader
        location={props.location}
        lockedUntilMs={props.lock.lockedUntilMs ?? undefined}
        onClickBack={handleClickBack}
        onLockExpiration={props.onLockExpiration}
        title="Reselect add-ons"
        subtitle={
          <Typography variant="body02">
            Please reselect your add-ons below before continuing.
          </Typography>
        }
        showOptions={props.showOptions}
      />
      <div className="Reschedule-body--calendar">
        <Options {...props} {...selectorProps} />
      </div>
    </div>
  );
};

export default RescheduleOptionsRoute;
